import { PbsCookieNames } from "../../models";

// The cookies are processed in the order they appear in this array,
// and processing stops at the first found cookie that has stopIfFound == true
export var cookiesToTransform = [{
  cookie: PbsCookieNames.PBS_CODE,
  queryParam: 'store',
  stopIfFound: true
}, {
  cookie: PbsCookieNames.ECREF_OWNER,
  queryParam: 'invite',
  stopIfFound: true
}, {
  cookie: PbsCookieNames.PBS_OWNER,
  queryParam: 'store',
  stopIfFound: false
}, {
  cookie: PbsCookieNames.PPL_CODE,
  queryParam: 'personallist',
  stopIfFound: true,
  stopIfFoundPrev: true,
  removeIfNotFound: true
}, {
  cookie: PbsCookieNames.ECREF,
  queryParam: 'invite',
  stopIfFound: true
}];